import React, { useState } from "react";
import { BiSlideshow } from "react-icons/bi";
import { GiNotebook } from "react-icons/gi";
import SciencePopUp from "../PopUp/Science/SciencePopUp";

/**
 * Displayes all events (Assesment, Slide show etc. ) in the event for week view
 * @param {*} param0
 * @returns
 */
const TimeTableWeekEvents = ({ event }) => {
  const [popup, setPopUp] = useState();
  return event ? (
    <div className="d-flex gap-2 mt-3">
      {event?.Events?.map((item, index) => {
        switch (item.name) {
          // case "assessment":
          //   return (
          //     <div key={index}>
          //       <GiNotebook size={"16px"} onClick={(e) => setPopUp(true)} />
          //     </div>
          //   );
          // case "activity":
          //   return (
          //     <div key={index}>
          //       <BiSlideshow size={"16px"} />
          //     </div>
          //   );
          // case "homework":
          //   return (
          //     <div key={index}>
          //       <BiSlideshow size={"16px"} />
          //     </div>
          //   );
          case "assessment":
            return (
              <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                {/* <Link className='link_dcm_summary' to='/ViewSummary'> */}
                <img src="/DCM-img/assessment.svg" alt=""></img>
                {/* </Link> */}
              </div>
            );
          case "homework":
            return (
              <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                {/* <Link className='link_dcm_summary' to='/ViewSummary'>  */}
                <img src="/DCM-img/homework.svg" alt=""></img>
                {/* </Link> */}
              </div>
            );
          case "activity":
            return (
              <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                {/* <Link className='link_dcm_summary' to='/ViewSummary'>  */}
                <img src="/DCM-img/activity.svg" alt=""></img>
                {/* </Link> */}
              </div>
            );
          case "pre_read":
            return (
              <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                {/* <Link className='link_dcm_summary' to='/ViewSummary'>  */}
                <img src="/DCM-img/preread.svg" alt=""></img>
                {/* </Link> */}
              </div>
            );
          default:
            return <></>;
        }
      })}
      {popup && <SciencePopUp setScience={setPopUp} />}
    </div>
  ) : (
    <></>
  );
};

export default TimeTableWeekEvents;
